var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMongodbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 245 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #b8c4c2;\r\n      }\r\n\r\n      .cls-2, .cls-5 {\r\n        stroke: #10aa50;\r\n        stroke-width: 15px;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #fff;\r\n        stroke-width: 21px;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #10aa50;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #12924f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "208.2 210.6 123.1 230 40.8 210.6 40.8 66.5 208.2 66.5 208.2 210.6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 124.5,
    cy: 45,
    rx: 85,
    ry: 35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.5,45v150c1.7,19.4,41,35.1,88,35.1s83.7-15.7,82-35.1V45M39.5,95c1.7,19.4,41,35.1,88,35.1s83.7-15.7,82-35.1h0M39.5,145c1.7,19.4,41,35.1,88,35.1s83.7-15.7,82-35.1h0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M166.3,100.3c-10.2-44.9-31.4-56.8-36.8-65.3-2.2-3.7-4.2-7.6-5.9-11.6-.3,4-.8,6.5-4.2,9.5-6.8,6.1-35.7,29.6-38.1,80.6-2.3,47.5,35,76.9,39.9,79.9,3.8,1.9,8.4,0,10.6-1.7,17.9-12.3,42.5-45.1,34.6-91.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.1,168.2c-.9,11.8-1.6,18.6-4,25.3,0,0,1.6,3.2,2.7,15.1h3.9c.9-8.4,2.3-8.7,4.2-16.8-5-2.5-6.6-13.2-6.8-23.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.9,191.7h0c-5.1-2.3-6.5-13.3-6.8-23.6,1.3-16.9,1.6-33.8,1.1-50.7-.3-8.9.1-82.2-2.2-93,1.6,3.6,3.4,7.2,5.5,10.6,5.4,8.5,26.6,20.4,36.8,65.3,7.9,46.3-16.5,79-34.4,91.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.3,100.3c-10.2-44.9-31.4-56.8-36.8-65.3-2.2-3.7-4.2-7.6-5.9-11.6-.3,4-.8,6.5-4.2,9.5-6.8,6.1-35.7,29.6-38.1,80.6-2.3,47.5,35,76.9,39.9,79.9,3.8,1.9,8.4,0,10.6-1.7,17.9-12.3,42.5-45.1,34.6-91.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.1,168.2c-.9,11.8-1.6,18.6-4,25.3,0,0,1.6,11.2,2.7,23.1h3.9c.9-8.4,2.3-16.7,4.2-24.8-5-2.5-6.6-13.2-6.8-23.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M131.9,191.7h0c-5.1-2.3-6.5-13.3-6.8-23.6,1.3-16.9,1.6-33.8,1.1-50.7-.3-8.9.1-82.2-2.2-93,1.6,3.6,3.4,7.2,5.5,10.6,5.4,8.5,26.6,20.4,36.8,65.3,7.9,46.3-16.5,79-34.4,91.4Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodbIcon);
export default __webpack_public_path__ + "static/media/mongodb_icon.53751a096eee8f62a951610e2574374a.svg";
export { ForwardRef as ReactComponent };